/* @flow weak */
import {Record} from '../transit';
import * as deviceActions from './actions';
import {fromJS, OrderedMap} from 'immutable';
import * as loginActions from "../login/actions";

const State = Record({
    name: '',
    organizationDomain: '',
    organizationName: '',
    id: null,
    formDisabled: false,
    silentPrint: false,
    billPrint: true,
    printType: 'off',
    printLength: 42,
    printTypeOptions: OrderedMap([['off', 'Vypnuto'], ['default', 'Výchozí tiskárna'], ['default-silent', 'Výchozí tiskárna (bez potvrzování tiskovým dialogem)'], ['escpos-usb', 'ESC/POS USB'], ['escpos-serial', 'ESC/POS Sériový port'], ['escpos-net', 'ESC/POS Síťová tiskárna'], ['escpos-bt', 'ESC/POS Bluetooth tiskárna']]),
    printAddress: '',
    kitchenPrintType: 'off',
    kitchenPrintLength: 42,
    kitchenPrintTypeOptions: OrderedMap([['off', 'Vypnuto'], ['default', 'Výchozí tiskárna'], ['default-silent', 'Výchozí tiskárna (bez potvrzování tiskovým dialogem)'], ['escpos-usb', 'ESC/POS USB'], ['escpos-serial', 'ESC/POS Sériový port'], ['escpos-net', 'ESC/POS Síťová tiskárna'], ['escpos-bt', 'ESC/POS Bluetooth tiskárna']]),
    kitchenPrintAddress: '',
    kitchenPrint: false,
    kitchenItemsPrintSeparate: false,
    fullScreen: true,
    host: '',
    isReactNative: false,
    platform: '',
    hideMouse: false,
    loginByPin: false,
    logoutTimer: null,
    logoutTimerOptions: OrderedMap([[30000, '30s'], [60000, '1min'], [120000, '2min'], [300000, '5min'], [600000, '10min']])
}, 'device');

const FORM_DISABLED = 'formDisabled';
const ID = 'id';
const NAME = 'name';
const ORGANIZATION_NAME = 'organizationName';

const deviceReducer = (state = new State(), action) => {

    switch (action.type) {
        case deviceActions.GET_ORGANIZATION_NAME_SUCCESS: {
            const {data} = action.payload;
            return state.set(ORGANIZATION_NAME, data);
        }

        case loginActions.API_LOGIN_SUCCESS: {
            const {device} = action.payload.data;
            if (!device) {
                return state;
            }
            const deviceMap = fromJS(device);
            return state
                .set(NAME, deviceMap.get('name'))
                .set(ID, deviceMap.get('id'))
        }

        case deviceActions.CHANGE_DEVICE_SETTINGS: {
            const {type, value} = action.payload;

            if (type === 'printType') {
                if (['escpos-serial', 'escpos-net', 'escpos-bt'].indexOf(value) > -1) {
                    return state
                        .set(type, value);
                } else {
                    return state
                        .set('printAddress', '')
                        .set(type, value);
                }
            } else if (type === 'kitchenPrintType') {
                if (['escpos-serial', 'escpos-net', 'escpos-bt'].indexOf(value) > -1) {
                    return state
                        .set(type, value);
                } else {
                    return state
                        .set('kitchenPrintAddress', '')
                        .set(type, value);
                }
            }

            return state
                .set(type, value);
        }
        case deviceActions.SET_DEVICE_NAME_ERROR: {
            return state
                .set(FORM_DISABLED, false);
        }
        case deviceActions.SET_DEVICE_NAME_START: {
            return state
                .set(FORM_DISABLED, true);
        }
        case deviceActions.SET_DEVICE_NAME_SUCCESS: {
            const {name, id} = action.payload.data;
            return state
                .set(NAME, name)
                .set(ID, id)
                .set(FORM_DISABLED, false);
        }
    }

    return state;

};

export default deviceReducer;



// WEBPACK FOOTER //
// ./src/common/device/reducer.js